module.exports = __webpack_public_path__ + "img/icon-users.eb8c99e9.svg";